import qs from "qs";

export default function encodeObjectToQueryString(obj) {
    return qs.stringify(obj);
}
